// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__FGp97","close-button":"style_close-button__DYwj6","closeButton":"style_close-button__DYwj6"};